var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerra(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288.9 274",
    style: {
      enableBackground: "new 0 0 288.9 274"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M151.1.3c33.7 0 64.9 12.1 88.7 32.9 31.8 24.5 22.6 113.9-9.6 90.3-70.8-.3-202.4-38.2-163.2-90.3 4-5.3 9-9.6 14.5-13.7h-.3c.9-.5 1.9-1 2.8-1.6.9-.5 1.9-1.1 2.8-1.6 2.8-1.6 5.6-3.1 8.7-4.3C112.5 4.6 131.3.3 151.1.3zm23.8 272.5c-14.2.9-42.6-21.4-50.7-50.9-15.1-55.9 107.2-84.4 118.7-85.4 31.2.9 38.9 38.2 16.1 76.7-29.7 49.4-83.5 59.6-84.1 59.6z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#2849a9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8 77.9c9.9 2.8 70.5-16.5 88.4-43.8.3-.3 14.2-21.7-12.7-22-3.1 0-11.7.3-20.1 5.3-4 2.5-7.7 5-11.4 7.8-5.8 4.3-11.3 9.5-16.5 14.4l-.2.2c-5.3 5-10.2 10.9-14.5 16.8-4.3 5.9-8.3 12.4-11.7 18.9-.2.5-.4.9-.6 1.2-.3.3-.5.7-.7 1.2zm71.7 194.9c1.9-2.8 3.1-36.6 1.9-45.3-1.2-8.7-4-26.4-20.7-55.6-2.8-4.7-16.1-26.4-26-39.7-5.6-7.8-11.7-15-17.8-22.3-5.1-6-10.2-12.1-15-18.4-.3.8-.5 1.5-.8 2.2s-.5 1.4-.8 2.2C4.8 103 3 110.5 1.7 118.3S0 133.8 0 141.8c0 8.1.6 15.8 1.9 23.6s3.4 15.2 5.6 22.4c2.2 7.1 5.3 14.3 8.7 20.8s7.4 13 11.7 18.9c4.3 5.9 9.3 11.5 14.5 16.8 4.9 5.3 10.8 10.2 16.7 14.6 4.6 3.1 9.3 6.2 13.9 9 8.5 5 11.7 5 13.4 5 0-.1 0-.1.1-.1zm202.4-131c0 18.9-3.7 36.9-10.2 53.4-15.7 17-115.3-20.7-130.8-26.6-1.2-.5-2-.7-2-.8-15.8-6.8-63.3-27.9-67.7-60.8-6.2-47.5 89.6-80.7 131.9-82 4.9 0 20.4.3 29.4 7.5 30.3 26.7 49.4 65.9 49.4 109.3zM188.8 260.1c-3.7 12.1 10.2 16.5 22.6 10.6 24.7-13 45.1-33.2 59-57.1.9-1.2 0-2.5-1.5-2.2-13.3 1.2-73.3 25.1-80.1 48.7z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#5795ed"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerra);
export default __webpack_public_path__ + "static/media/terra.77cd51a6fb8dbae70872b3d3b813c2ab.svg";
export { ForwardRef as ReactComponent };